var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.1121,
    r: 10,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.08 14.1121H10.24C10.24 13.6854 10.336 13.2854 10.528 12.9121C10.72 12.5281 10.9547 12.2027 11.232 11.9361C11.5094 11.6587 11.7867 11.3974 12.064 11.1521C12.3414 10.8961 12.576 10.6187 12.768 10.3201C12.96 10.0214 13.056 9.71741 13.056 9.40808C13.056 8.97075 12.9014 8.62941 12.592 8.38408C12.2827 8.13875 11.8667 8.01608 11.344 8.01608C10.8427 8.01608 10.4107 8.14408 10.048 8.40008C9.68537 8.65608 9.42404 9.01875 9.26404 9.48808L7.68004 8.59208C7.96804 7.84541 8.44271 7.26408 9.10404 6.84808C9.77604 6.43208 10.5387 6.22408 11.392 6.22408C12.352 6.22408 13.1734 6.49608 13.856 7.04008C14.5494 7.58408 14.896 8.33608 14.896 9.29608C14.896 9.73341 14.8 10.1494 14.608 10.5441C14.416 10.9387 14.1814 11.2747 13.904 11.5521C13.6267 11.8294 13.3494 12.1014 13.072 12.3681C12.7947 12.6241 12.56 12.9014 12.368 13.2001C12.176 13.4987 12.08 13.8027 12.08 14.1121ZM11.168 15.4241C11.4987 15.4241 11.7814 15.5414 12.016 15.7761C12.2507 16.0107 12.368 16.2934 12.368 16.6241C12.368 16.9547 12.2507 17.2374 12.016 17.4721C11.7814 17.7067 11.4987 17.8241 11.168 17.8241C10.8374 17.8241 10.5547 17.7067 10.32 17.4721C10.0854 17.2374 9.96804 16.9547 9.96804 16.6241C9.96804 16.2934 10.08 16.0107 10.304 15.7761C10.5387 15.5414 10.8267 15.4241 11.168 15.4241Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.f246993c67404165e1f2710896e358f8.svg";
export { ForwardRef as ReactComponent };